import { render, staticRenderFns } from "./ProfileLiked.vue?vue&type=template&id=64ed2f9a"
import script from "./ProfileLiked.vue?vue&type=script&lang=js"
export * from "./ProfileLiked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports